<template>
	<div class="ReSearchMObjBig" v-if="objData">
		<card> 
			<div class="row mx-0 align-items-center">
				<div class="bntGroup">
					<base-button type="primary" class="groupfloor" simple @click="backByHistory()" ><i class="tim-icons icon-double-left mr-2"></i>Назад</base-button>
				</div>
						
			</div>
			<div class="row ">
				<div class="col-lg-8 col-12 pr-0 order-2 order-lg-1">
			
				<div class="flatHeader">
					<div class="flatTitles">
						<div class="row px-3">	
							<div  v-if="objData.promo"><span class="badge badge-primary mr-2">промо</span></div>				
							<h4 class="mr-3">ID {{objData.id}}</h4>
							<h4>{{objData.name}}</h4>
						</div>
						<div class="row px-3">
							<p class="mr-3">Добавлено {{$GVO.convertDateTimeFromMysql(objData.insertTime)}}</p>
							<p class="mr-3">Обновлено {{$GVO.convertDateTimeFromMysql(objData.updateTime)}}</p>  
							<!-- <div class="d-flex">
								<p class="mr-2">Cоздатель объекта: </p>
								<a :href="'/data/staff/id/'+objData.agent_id"> {{objData.agent_fio}}</a>
							</div>	                -->
							<!-- <div class="d-flex" v-if="objData.service_agent_id!='undefined' || objData.service_agent_fio!='undefined'">
								<p class="mr-2">Ответственный за услугу: </p>
								<a :href="'/data/staff/id/'+objData.service_agent_id"> {{objData.service_agent_fio}}</a>
							</div>	                -->
						</div>
					
					<div class="row align-items-center mx-0">
						<span class="badge badge-default mr-2" style="font-size: 12px;">{{objData.dealType}}</span>
						<span class="badge badge-default mr-2" style="font-size: 12px;">{{objData.objectType}}</span>
						<span class="badge badge-danger mr-2" style="font-size: 12px;" v-if="objData.act =='0'">Объект в архиве</span>
						<span class="badge badge-danger mr-2" style="font-size: 12px;" v-if="objData.draft && objData.draft!='undefined' && objData.draft ==true">Черновик</span> 
						<span class="badge badge-success mr-2" style="font-size: 12px;" v-if="objData._actual!='undefined' && objData._actual==1">Актуально</span>
						<span class="badge badge-info mr-2" style="font-size: 12px;" v-if="objData._actual!='undefined' && objData._actual==0 && objData.export_sites_count=='0'">Снято</span>
					</div>	
					</div>
					<div class="row mx-0 align-items-center">
						<div class="bntGroup" >		
							<el-tooltip content="История изменений" placement="top">			
								<button type="button" class="btn my-0 btn-icon btn-fab btn-primary btn-simple mr-2" @click="GoToHistory(objData.id)"><i class="d-inline-block tim-ic ic-history"></i></button>
							</el-tooltip>	
						</div>		
						<div class="bntGroup" v-if="objData.act =='1'">						
							<button type="button" class="btn my-0 btn-icon btn-fab btn-primary btn-simple" @click="GoToEdit(objData)"><i class="d-inline-block tim-icons icon-pencil"></i></button>
						</div>		
					</div>
				</div>

				<div class="flatInfo mb-5">
					<div class="col-sm-12 col-md-6 flatPhotos">
						<div class="flat-carousel mb-4">
							<el-carousel :autoplay="false" arrow="always" height="400px" v-if="objData.photos && objData.photos.length > 0">
								<el-carousel-item v-for="obj_img in objData.photos" :key="obj_img.id">
									<img v-if="obj_img !=''" :src="obj_img" alt="">
								</el-carousel-item>
							</el-carousel>
							<div>
								<img v-if="!objData.photos || objData.photos.length == 0" src="/img/flatsDefault.svg" style="height: 100%;" alt=""> 
							</div>
						</div>
						<div class="d-flex mb-3" v-if="objData.videoUrl">
							<a :href="objData.videoUrl" target="_blank">Посмотреть видео</a>						
						</div>
						<div class="row" v-if="objData.description!='' || objData.description!=null">
							<div class="col-sm-12">
								<div class="d-flex flex-wrap align-items-baseline">
									<h4 class="mb-0 mr-2">Описание </h4>
									<p class="objectDescrNumber"> (количество символов: {{ (objData.description||'').length }})</p>
								</div>
								<div class="objectDescr"><p>{{objData.description}}</p></div>
							</div>
						</div>
					</div>
					<div class="col-sm-12 col-md-5 flatPass px-4">
						<div class="clientinfo mb-3"> 
							<div class="d-flex flex-wrap mb-2">
								<p class="mr-2 mb-0">Клиент: </p>
								<!-- <a :href="'/data/clients/id/'+objData.client_id"> посмотреть профиль</a> -->
								<router-link :to="'/data/clients/id/'+objData.client_id+'?phoneint='+this.phoneintClientContsct.concact_phone_INT"> посмотреть профиль</router-link>
							</div>
							<div class="d-flex flex-wrap mb-2">
								<p class="mr-2 mb-0">Услуга: </p>
								<router-link :to="'/data/clients/id/'+objData.client_id+'?phoneint='+this.phoneintClientContsct.concact_phone_INT+'&service='+objData.service_id">посмотреть услугу</router-link>
							</div>
							<div class="d-flex flex-wrap align-items-center mb-2" v-if="objData.service_agent_id!='undefined' || objData.service_agent_fio!='undefined'">
								<p class="mr-2 mb-0">Ответственный за услугу: </p>
								<div class="d-flex justify-content-between align-items-center">
									<router-link :to="'/data/staff/id/'+objData.service_agent_id"> {{objData.service_agent_fio}}</router-link>
									<template v-if="getObjects" class="ml-1">
										<el-popover
											placement="left"
											:title="objData.service_agent_fio"
											width="500"
											trigger="click"
											>
											<template v-slot:reference>
												<base-button class="btn btn-icon no-border btn-simple btn-primary my-0 ml-2 btn-watch-icon"><i class="tim-ic ic-eye"></i></base-button>
											</template>
											<template v-slot:default>
												<div class="col" >
													<ReLeadStaffInfo :objData="getObjects"  />
													<!-- <ReLeadStaffInfo :objData="leadStaffInfo" :lead_id="ApiData.id" /> -->
												</div>
											</template>
											
										</el-popover>
									</template>	
								</div>
							</div>	
							<!-- <p>Согласие на рекламу: <span > № {{  }}</span></p> -->
							<p><re-agrm-info :info="objData"></re-agrm-info></p>

							

						</div>	
						<collapse activeIndexType="all" >
							<collapse-item :title="description" >
								<div class="flatPass-container">
									<div class="flatPass-row"><h3 class="text-success">{{ $GVO.number_format(objData.price,0,'.',' ') }} ₽</h3></div> 
									<template v-for="(config,c_index) in flatProps.description">
										<ReFlatRow 
										:key="c_index"
										v-if="!config.show || config.show(objData)"
										:value="config.getValue?config.getValue(objData):config.value?objData[config.value]:true"
										:title="config.title"
										:draw="config.draw"
										:titleComputed="config.titleComputed"
										/>
									</template>
									<template v-if="objData.parts && objData.parts.length >0">
										<div v-for="(objPart, indx) in objData.parts" :key="indx" class="flatPass-row objDots" >
											<p>S и стоимость части {{ ++indx }}</p><span></span><p>{{$GVO.number_format(objPart.price,0,'.',' ')}} ₽ за {{objPart.square}} м²</p>
										</div>
									</template>
									<template v-for="(config,c_index) in flatProps.description2" >
										<ReFlatRow 
										v-if="!config.show || config.show(objData)"
										:key="c_index + '_2'"
										:value="config.getValue?config.getValue(objData):config.value?objData[config.value]:true"
										:title="config.title"
										:draw="config.draw"
										:titleClass="config.titleClass"
										/>
									</template>
								</div>	

								<div class="flatPass-container mt-4"  v-if="objData.newFlat">
									<h6>Информация по новостройкам</h6>
									<template v-for="(config,c_index) in flatProps.newflat" >
										<ReFlatRow 
										v-if="!config.show || config.show(objData)"
										:key="c_index"
										:value="config.getValue?config.getValue(objData):config.value?objData[config.value]:true"
										:title="config.title"
										:draw="config.draw"
										:titleClass="config.titleClass"
										/>
									</template>
									<div class="flatPass-row " v-if="objData.documentationUrl">
										<p>Ссылка на проектную документацию: <a :href="objData.documentationUrl" target="_blank" style="max-width: 240px; word-break: break-all;">{{objData.documentationUrl}}</a></p>
										
									</div>
								</div>					
								
							</collapse-item>
							<!-- <div class="contats-booking" v-if="isOpenContacts == false">
								<ReCuratorContacts/> 
							</div> -->
							
						</collapse>  

						
												
					</div>
				</div>

				
				<div class="objectInfo mb-3 pb-4">    
					<div class="col-sm-12 col-md-6 windowMap">					
						<h4>Расположение</h4>					
						<div class="">
							<div class="metro mr-2">
								<ul class="metro-row" v-if="objData.MapAddress">								
									<li v-for="metro in objData.MapAddress.arrMetro" :key="metro.id">
										<div class="metro-row mr-2" v-if="metro.metro_name">
											<div class="d-inline-flex mr-2" v-if="metro.metro_name != ''">
												<i class="tim-ic ic-metro text-primary mr-1"></i>
												<p>{{metro.metro_name}}</p>
											</div> 
											<div class="d-inline-flex align-items-baseline">
												<i v-if="metro.distanceType == 'WALK'" class="metroIc tim-icons icon-user-run text-primary"></i> 
												<i v-if="metro.distanceType == 'TRANSPORT'" class="metroIc tim-icons icon-bus-front-12 text-primary"></i> 
												<!-- <p  v-if="metro.distanceToMetro != ''">{{metro.distanceToMetro}} мин.,</p>		 -->
												<p  v-if="metro.distanceToMetro != ''">{{distanceInHours(metro.distanceToMetro)}} ,</p>		
																			
											</div> 
										</div>	
									</li>								
								</ul>
							</div>
							<p v-if="objData.MapAddress || objData.address">
								<span v-if="objData.address && objData.address.text!='undefined'">{{objData.address.text}}, </span>
								<span v-else>{{objData.MapAddress.address.inputText}}, </span>
								 
								<!-- <span v-if="objData.MapAddress.distr_name "> р-н {{objData.MapAddress.distr_name}}, </span> -->
								<span v-if="objData.MapAddress.flat_num && (objData.objectType == 'Квартиры' || objData.objectType =='Новостройки' ||objData.objectType =='Комната')">номер квартиры</span>
								<span v-if="objData.MapAddress.flat_num && objData.objectType == 'Дома'">номер дома</span>
								<span v-if="objData.MapAddress.flat_num && objData.objectType == 'Земля'">номер участка</span>
								<span v-if="objData.MapAddress.flat_num && objData.objectType == 'Комм.Земля'">номер земли</span>
								<span v-if="objData.MapAddress.flat_num && objData.objectType == 'Помещения'">номер офиса (помещения)</span>
								<span v-if="objData.MapAddress.flat_num && objData.objectType == 'Склады'">номер склада</span>
								<span v-if="objData.MapAddress.flat_num && objData.objectType == 'Гаражи'">номер гаража</span>
								<span v-if="objData.MapAddress.flat_num && objData.objectType == 'Машиноместа'">номер паркинга (машиноместа)</span>
								
								{{objData.MapAddress.flat_num}}
							</p> 
						</div>
						<div class="map mt-2">
							<!-- <div class="embed-responsive embed-responsive-16by9" v-if="objData.gid != ''">
								<iframe class="embed-responsive-item" :src="`https://web.3bita.ru/floorplan/widgets/widget.html?gid=${objData.gid}&zoom=17&caption=false`" allowfullscreen allowusermedia></iframe>
							</div> -->
							<div >
								<yandex-map
									:settings="yamap_settings"
									:coords="yamap_coords"
									:zoom="yamap_zoom"
									:scroll-zoom="false"
									:controls="yamap_controls"
									>
								
									<ymap-marker
											:coords="yamap_markers.coords"
											:marker-id="yamap_markers.id"
											marker-type="placemark"
									/>

								</yandex-map>
							</div>
						</div>
					</div><!--objectMap  заглушка-->

					<div class="col-sm-12 col-md-5 flatPass px-4">
						<collapse activeIndexType="all">
							<collapse-item :title="features" >
								<div class="flatPass-container">
									<template v-for="(config, c_index) in flatProps.features">

										<ReFlatRow 
										:key="c_index"
										v-if="!config.show || config.show(objData)"
										:value="config.getValue?config.getValue(objData):config.value?objData[config.value]:true"
										:title="config.title"
										:draw="config.draw"
										:titleClass="config.titleClass"
										/>
									</template>
									<div class="mb-2" v-if="objData.feature">
										<p>Опции</p>
										<ul class="list-unstyled result-marker">
										<li class="" v-for="item in objData.feature" :key="item.id">
											{{item}}
										</li>
										</ul>
									</div>
							
								</div>
							</collapse-item>
						</collapse>    
					</div>
				</div>
				
				</div>	

				<div class="col-lg-4 col-12 order-1 order-lg-2 sticky-container" v-if="objData.act =='1'"> 
					<div class="sticky-item">
						<div class="zipal-errors mb-3" v-if="objData.zipal_error!='' && objData.zipal_error!=null">
							<h4 class="text-danger"><i class="tim-icons text-danger icon-alert-circle-exc mr-2"></i>Исправьте ошибки объекта, полученные при отправке</h4>
							<p class="zipal-error-text">{{ objData.zipal_error }}</p>	
						</div>
						<!-- <div class="zipal-errors mb-3" v-if="objData.zipal_error!='' && objData.zipal_error!=null">
							<h4 class="text-danger"><i class="tim-icons text-danger icon-alert-circle-exc mr-2"></i>Исправьте ошибки рекламы?</h4>
							<p class="zipal-error-text">{{  }}</p>	
						</div> -->
						<ReModeration v-on:moderationStatus="receiveEmitAnchor" />
					</div>	
				</div>

			</div>

			<template  v-if="(objData.moderation_status_id !='2' && this.emitStatusData != 2) && (objData._actual!='undefined' && objData._actual==0 )">
				<div class="col-lg-8 col-12 px-0">
					<div class="zipal-errors mb-5" style="">
						<h3 class="warning-msg text-danger mb-1"><i class="tim-icons icon-alert-circle-exc"></i> Информация по выгрузке в рекламу доступна только после модерации объекта</h3>
						<!-- <p class="text-danger mb-3">К объекту не привязан ни один пакет (автоматический тоже не привязан)</p> -->
					</div>
				</div>
			</template>

			<!-- <div v-if="(objData.act =='1' && this.emitStatusData == 2 && objData.moderation_status_id != '1') || (objData.act =='1' && objData.moderation_status_id =='2' )"> -->

			<template v-if="objData.act =='1' &&  (this.emitStatusData == 2 || objData.moderation_status_id == 2 ) || (objData.moderation_status_id == 1 && objData.export_sites_count>'')">
				<ReMediaPlan 
					:objId="objData.id"
					:deal_type="objData.dealType"
					:object_type="objData.objectType"
					:regionId="objData.MapAddress.address.regioncode"
					:actual="objData._actual"
					:hasAutoProlongate="objData.agent_id == $GVO.my_profile.code"
				/>
			</template>	

			<tabs type="primary" 
			:activeTab="strCurrentTab"
			@change="OnTabChange"
            tabContentClasses="tab-opt"
            
            inline
            round	
			v-loading.fullscreen.lock="$GVO.fullscreenLoading"
			element-loading-text="Загрузка данных..."
			element-loading-spinner="el-icon-loading"
			element-loading-background="rgba(0, 0, 0, 0.8)"	
            class="card card-plain mt-3 mt-xl-0 stat-tabs">
			<tab-pane :id="'buyers'">
			    <template v-slot:label>
			        <span class="tab-label">
			            <span>Обращения по объекту</span>
			        </span>
			    </template>

				<div ref="pagination">
					<template v-if="arrServices.length>0" >
						<h3>Обращения по объекту</h3>
						<ReSearchCardService v-for="(objService,index) in arrServices" :objService="objService" :key="index"/>

						<Pagination class="mt-3" :class="[{'': parseInt(masApi_total) > 0}, {'d-none': parseInt(masApi_total) < 1}]"
							:type="'info'" 
							:total="parseInt(masApi_total)" 
							:perPage="parseInt(count2page)"
							:value="parseInt(typeof objGetParams.p == 'undefined' ? 1:objGetParams.p)"
							:pClick="pClick">
						</Pagination>
					</template>
					<template v-else >Нет данных</template>
				</div>
				
							
			</tab-pane>
			<tab-pane :id="'stats'">
				
                <template v-slot:label>
					<span class="tab-label">
						<span>Статистика обращений по объекту</span>
					</span>
                </template>
				<div>
					<h3>Статистика по дням</h3>

					<div class="row row-wrap mt-2 mb-2">
						<div class="col-12 col-md-4" v-for="(value, key) in statsKeys" :key="key">
							<h6 class="text-primary">{{ statNames[value]||value }}</h6>
							<p v-for="(count, name) in servicesStat[value]" :key="name">{{ name }}: {{ count }}</p>
						</div>
					</div>

					<div class="stat-conf mt-2">
						<div class="stat-conf-item">
							<span>Показывать источники</span>
							<base-switch 
								v-model="groupServicesByAds"
								type="primary"
								on-text="On"
								off-text="Off"
							></base-switch> 
						</div>
						<div class="stat-conf-item">
							<span>Даты с обращениями</span>
							<base-switch 
								v-model="groupServicesAsEmptyDate"
								type="primary"
								on-text="On"
								off-text="Off"
							></base-switch>
						</div>
						<div class="ml-3 stat-conf-item">
							<el-select
								class="col-md px-0 mb-2 select-primary"
								v-model="groupServiceField" 
								placeholder="Группировать по "
								size="large"
							>
								<el-option
									class="select-primary"
									v-for="field in groupServiceFieldArr"
									:key="field.value"
									:label="field.label"
									:value="field.value"
								>
								</el-option>
							</el-select>
						</div>
						<div class="ml-3 stat-conf-item">
							<ReDateRange 
								v-model="objServiceDTRange"
							/>
						</div>
						<div class="ml-3 stat-conf-item">
							<button class="mb-2 btn btn-icon btn-simple btn-primary" @click="getServicesSum()">
								<i class="tim-icons icon-refresh-01"></i>
							</button>
						</div>
					</div>
					<!--pre>{{ arrServicesDays }}</pre-->
					<div v-if="this.arrServicesDays" >
						<ReServiceCharts
							:TheData="arrServicesDays"
							:group-ads="groupServicesByAds"
							:useDate="groupServicesAsEmptyDate"
							:groupTime="groupServiceField"
						/>
					</div>
				</div>		
			</tab-pane>
			<tab-pane id="goSimular" v-if="objData.draft!==true">
			    <template v-slot:label>
			        <span class="tab-label">
			            <span>Покупатели на похожий объект</span>
			        </span>
				</template>
			</tab-pane>
		</tabs>

			
		</card>        
		<!--pre>{{objData}}</pre-->
	</div>
</template>

<script>
import { TabPane, Tabs, Collapse, CollapseItem, BaseSwitch } from 'src/components';
import { Carousel, CarouselItem, Tooltip, Select, Option, Button, Popover } from "element-ui";
// import LineChart from 'src/components/Charts/LineChart';
// import {  Slider } from 'src/components/index';
// import ReCuratorContacts from 'src/our_components/ReCuratorContacts.vue'; 
import { yandexMap, ymapMarker } from 'vue-yandex-maps';
import mapSettings from 'src/conf/yandexmap.js';

import ReMediaPlan from 'src/our_modules/MarketingModule/ReMediaPlan.vue';
// import ReMarketingSitesOnObj from 'src/our_modules/MarketingModule/ReMarketingSitesOnObj.vue';
import ReModeration from 'src/our_modules/MarketingModule/ReModeration.vue';
import ReSearchCardService from 'src/our_components/ReSearchCardService.vue';

import ReLeadStaffInfo from 'src/our_components/ReLeadStaffInfo.vue';
import ReAgrmInfo from 'src/our_components/ReAgrmInfo.vue';
import Pagination from 'src/our_components/RePagination';
import ReServiceCharts from 'src/our_modules/MarketingModule/ReServiceCharts.vue';
import ReDateRange from "src/our_components/ReDateRange.vue";
import ReFlatRow from './ReFlatRow.vue';

export default {
	name: 'ReSearchMObjBig',
	components: {
		Collapse,
		CollapseItem,
		BaseSwitch,
		[Carousel.name]: Carousel,
		[CarouselItem.name]: CarouselItem,
		// LineChart,
		// Slider,
		// ReCuratorContacts,
		yandexMap, ymapMarker,
		ReMediaPlan,
		// ReMarketingSitesOnObj,
		ReModeration,
		// Tooltip,
		ReSearchCardService,
		[Button.name]: Button,
		[Tooltip.name]: Tooltip,	
		[Popover.name]: Popover,
        [Option.name]: Option,
        [Select.name]: Select,		
		ReLeadStaffInfo,
		ReAgrmInfo,
		Pagination,
		TabPane, 
		Tabs,
		ReServiceCharts,
		ReDateRange,
		ReFlatRow
	},
	props: {
		// objData: Object,
		findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
			type: String,
			default: '',
		},
		description: {
			type: String,
			default: 'Описание',
		},
		features: {
			type: String,
			default: 'Особенности',
		},
		objData: Object,
	},
	data () {
		return {
			ver: 1,
			Banks_orig: [],
			isOpenContacts: true,
			arrServices:[],
			arrServicesDays: [],
			servicesStat: {},
			statLoad: false,
			statNames:{
				totalCount:'За всё время',
				last30DaysCount:'За последние 30 дней',
				last7DaysCount:'За последние 7 дней',
			},
			yamap_settings: {...mapSettings},
			yamap_coords: [59.93984485554249, 30.314527237792984],
			yamap_zoom: 17,
			yamap_controls:['zoomControl','typeSelector'],
			yamap_markers:{
				coords: [59.93984485554249, 30.314527237792984],
				id: '1',
			},
			masImgs:'',
			activeItem: null,
			// client_contacts: [],
			phoneintClientContsct: {},
			emitStatusData: '',
			masApi_total: 0,
			count2page: 10,
			objGetParams:{},
			strCurrentTab: 'buyers',
			groupServicesByAds: false,
			groupServicesAsEmptyDate: false,
			
			groupServiceField: 'day',
			groupServiceFieldArr:[
				{value:'day', label:'по дням'},
				{value:'week', label:'по неделям'},
				{value:'month', label:'месяц'},
			],
			objServiceDTRange:{startDt:this.addMonths(new Date(),-1),endDt:new Date()},
			objMediaDTRange:{startDt:this.addMonths(new Date(),-1),endDt:new Date()},
			flatProps:{
				description:[
					{value: 'offerType', title:'Тип предложения'},
					{value: 'Period', title:'Срок аренды'},
					{value: 'PriceType', title:'Период оплаты'},
					{value: 'deposit', title:'Депозит', draw:this.drawAmount},
					{value: 'prepayment', title:'Предоплата, мес.'},
					{show(objData){return (Object.prototype.hasOwnProperty.call(objData,'utilityMeters')) && objData.dealType  == 'Аренда'}, title:'Оплата по счетчикам производится', draw:this.drawUtilityMeters},
					{show(objData){return (Object.prototype.hasOwnProperty.call(objData,'otherUtilities')) && objData.dealType  == 'Аренда'}, title:'Оплата коммунальных услуг производится', draw:this.drawOtherUtilities},
					{show(objData){return objData.dealType  == 'Аренда' && objData.otherUtilitiesPayment && objData.otherUtilities  == true}, title:'Оплата коммунальных услуг (квитанция, без счетчиков), руб', draw:this.drawOtherUtilitiesPayment},
					{value: 'parts_price', title:'Цена части', draw:this.drawAmount},
					{value: 'VatType', title:'Налог'},
					{value: 'utilities', title:'Оплата по счетчикам, руб', draw:this.drawAmount},
					{value: 'commission', title:'Размер комиссии, %'},

					{value:'square', title:'S общая', draw:this.drawM2Sot},


					{value:'usefulSquare', title:'S полезная', draw:this.drawM2},					
					{value:'kitchenSquare', title:'S кухни', draw:this.drawM2},					
					{getValue(obj){return obj.chambers && obj.chambers.textval}, title:'S комнат', draw:this.drawM2},					
					{value:'landSquare', title:'S участка', draw:this.drawSot},	

					{value:'minSquare', title:'Минимальная площадь', draw:this.drawM2Sot},
					{value:'roomsCount', title: '', titleComputed: this.titleRoomsCount, },
					{value:'roomsCountTotal', title:'Комнат всего', },
					{value:'separatedRoomsCount', title:'Комнат раздельно', },
					{value:'byPart', title:'Можно частями', draw:this.drawYes},
				],
				description2:[
					{show(objData){return (objData.floor || objData.floors);}, getValue(objData){
						return ((objData.groundFloor && objData.groundFloor==true)?'Цоколь или Подвал /':(objData.floor?objData.floor+' / ':''))+objData.floors;
					}, title:'Этаж/Этажность', },
					{value:'flatStatus', title:'Статус объекта', },
					{value:'material', title:'Материал стен', },
					{value:'material_house', title:'Материал стен', },
					{value:'Toilet', title:'Санузел', },
					{value:'Heating', title:'Отопление', },
					{value:'Furniture', title:'Мебель', },
					{value:'flatHouseType', title:'Тип здания', },
					{value:'series', title:'Серия дома', },
					{value:'flatType', title:'Тип квартиры', },
					{value:'privatization', title:'Приватизированная квартира', draw:this.drawYes },
					{value:'apartments', title:'Апартаменты', draw:this.drawYes },
					{value:'neighbor', title:'Соседей в квартире', },
					{show(objData){objData.sharePercent && (objData.sharePercent.sharePart!='' || objData.sharePercent.shareAll !='')}, title:'Размер доли', draw(){return this.objDataobjData.sharePercent.sharePar+' из ' + this.objData.sharePercent.shareAll}},
					{value:'burden', title:'Есть обременения', draw:this.drawYes},
					{value:'mortgage', title:'Ипотека', draw:this.drawYes},
					{value:'credit', title:'Рассрочка', draw:this.drawYes},
					{value:'exclusiveContract', title:'Эксклюзивный договор с собственником', draw:this.drawYes},
					//  RENT FALT
					{value:'maxPeople', title:'Максимальное количество человек'},
					// BUSINESS COMM_LAND 
					{value:'BuildingClass', title:'Класс здания'},
					{value:'Layout', title:'Планировка'},
					{value:'BuildingType', title:'Тип здания'},
					{value:'ObjectCondition', title:'Состояние объекта'},
					{value:'centerName', title:'Название БЦ'},
					{value:'parkingPlaces', title:'Количество парковочных мест'},
					{value:'ParkingType', title:'Тип парковки'},
					{value:'ParkingType_warehouse', title:'Тип парковки'},
					{value:'BusinessUsageType', title:'Тип использования помещения'},
					{value:'hallSquare', title:'Площадь холла',draw: this.drawM2},
					{value:'EntryType', title:'Вход в объект'},
					{value:'standaloneBuilding', title:'Отдельностоящее здание', draw:this.drawYes},
					{value:'readyBusiness', title:'Готовый бизнес',draw:this.drawYes},
					//  HOUSE LAND COMM_LAND 
					{value:'year', title:'Год постройки'},
					{value:'LandUsageType', title:'Вид разрешенного использования', titl1eClass:'text-right'},
					{value:'communityName', title:'Название сообщества'},
					{value:'Purpose', title:'Категория земли'},
					{value:'railway', title:'Ж/Д станция'},
					{value:'railwayDistance', title:'До Ж/Д станции, мин.'},
					{value:'waterDistance', title:'До водоема, м'},
					{value:'Shape', title:'Форма участка'},
					{value:'Relief', title:'Рельеф'},
					{value:'Electricity', title:'Электроснабжение'},
					{value:'Gas', title:'Газификация'},
					{value:'Plumbing', title:'Водоснабжение'},
					{value:'Sewerage', title:'Канализация'},

					// WAREHOUSE
					{value:'WarehouseType', title:'Тип складского помещения'},
					{value:'Conditioning', title:'Система контроля климата'},
					{value:'storageType', title:'Тип хранения'},
					{value:'floorPressure', title:'Нагрузка на пол, тонн'},
					{value:'columnSpace', title:'Шаг колонн, м'},
					{value:'power', title:'Подведенная мощность, кВт'},
					{value:'warehouseFloor', title:'Покрытие полов'},
					{value:'Unloading', title:'Разгрузка'},
					{value:'Gate', title:'Въезд'},
					{value:'HighwayAccess', title:'Транспортная доступность'},
					{value:'StructureType', title:'Тип здания'},
					{value:'sublease', title:'Субаренда', draw:this.drawYes},
					// GARAGE
					{value:'GarageType', title:'Тип гаража'},
					{value:'stories', title:'Этажность здания'},
					{value:'GarageMaterial', title:'Материал стен'},
					{value:'totalParkingLots', title:'Общее количество машиномест'},
					{value:'assignmentOfLeaseRights', title:'Переуступка права аренды', draw:this.drawYes},
					{value:'totalParkingLots', title:'Тип стоянки'},

				],
				newflat:[
					{value:'firstSale', title:'Первичная продажа вторички', draw:this.drawYes},
					{value:'newFlat', title:'Готовность объекта'},
					{getValue(obj){if(obj.readyDate_quarter && obj.readyDate_year) return [obj.readyDate_quarter, obj.readyDate_year].join(' ')}, title:'Дата сдачи'},
					{value:'developer', title:'Застройщик'},
					{value:'buildingName', title:'Название ЖК'},
					{value:'reassignment', title:'Переуступка', draw:this.drawYes},
					{value:'investorType', title:'Тип дольщика'},
					{getValue(obj){if(obj.investorLastName || obj.investorPatronymic || obj.investorFirstName) return [obj.investorLastName, obj.investorFirstName, obj.investorPatronymic].join(' ')}, title:'Имя дольщика'},
					{value:'investorInn', title:'ИНН (если дольщик юр. лицо)'},
				],
				features:[
					{value:'cadastralNumber', title:'Кадастровый номер'},
					{value:'landCadastralNumber', title:'Кадастровый номер участка'},
					{value:'renovation', title:'Ремонт'},
					{value:'renovation_newflat', title:'Ремонт'},
					{value:'plumbing', title:'Водоснабжение'},
					{value:'ceilingHeight', title:'Высота потолка, м'},
					{value:'balcony', title:'Количество балконов'},
					{value:'Loggia', title:'Количество лоджий'},
					{value:'Elevator', title:'Пассажирских лифтов'},
					{value:'ServiceElevator', title:'Грузовых лифтов'},
					{value:'WindowView', title:'Вид из окон'},
					{value:'windowMaterial', title:'Материал окон'},
					{value:'ApartmentPosition', title:'Расположение окон в доме'},
					{value:'door', title:'Входная дверь'},
					{value:'flatFloor', title:'Покрытие пола'},
				]
			}
		}
	},
	watch: {
		objData: function(val){
			this.yamap_coords = [this.objData.MapAddress.coords[0],this.objData.MapAddress.coords[1]];
			this.yamap_markers.coords = [this.objData.MapAddress.coords[0],this.objData.MapAddress.coords[1]];
			//console.log('watch objData to log');
			this.getServices();
			this.getClientContacts();
		},
		// '$route' (to, from) {
		// 	let fromRoot = from.fullPath;
		// 	let toRoot = to.fullPath;
		// 	console.log('fromRoot', fromRoot);
		// 	console.log('toRoot', toRoot);
		// 	// if(from.includes('data/callcenter')){
		// 	// 	//location.pathname.includes('data/module/mo/object')
		// 	// 	// this.bIsShown = true;
		// 	// 	console.log('hohoho');
		// 	// }
		// },
		/*
		groupServiceField(){
			this.getServicesSum()
		},
		*/
	},
	computed: {
		statsKeys() {
			return Object.keys(this.statNames);
		},
		getObjects: function(){
			let objectsarr = {};
			if(this.objData !='' && typeof this.objData !='undefined'){
				// this.masLeadObjects = JSON.parse(this.ApiData.objects_json);
				objectsarr={
					staff_info_boss_internal_phone:this.objData.staff_info_boss_internal_phone,
					staff_info_boss_mobile_phone:this.objData.staff_info_boss_mobile_phone,
					staff_info_boss_name:this.objData.staff_info_boss_name,
					staff_info_boss_phone:this.objData.staff_info_boss_phone,
					staff_info_internal_phone:this.objData.staff_info_internal_phone,
					staff_info_mobile_phone:this.objData.staff_info_mobile_phone,
					staff_info_poz_name:this.objData.staff_info_poz_name,
					staff_info_structure_name:this.objData.staff_info_structure_name};
				// console.log('objectsarr',objectsarr);
			} 
			// if(this.objData !='' && typeof this.objData !='undefined'){
			// 	// this.masLeadObjects = JSON.parse(this.ApiData.objects_json);
			// 	objectsarr.push([{
			// 		staff_info_boss_internal_phone:this.objData.staff_info_boss_internal_phone,
			// 		staff_info_boss_mobile_phone:this.objData.staff_info_boss_mobile_phone,
			// 		staff_info_boss_name:this.objData.staff_info_boss_name,
			// 		staff_info_boss_phone:this.objData.staff_info_boss_phone,
			// 		staff_info_internal_phone:this.objData.staff_info_internal_phone,
			// 		staff_info_mobile_phone:this.objData.staff_info_mobile_phone,
			// 		staff_info_poz_name:this.objData.staff_info_poz_name,
			// 		staff_info_structure_name:this.objData.staff_info_structure_name,}]);
				
			// } 
			return objectsarr;
		},
	
	},
	methods: {
		drawYes(){return 'Да';},
		drawAmount(amount){
			return this.$GVO.number_format(amount,0,'.',' ')+' ₽'
		},
		drawM2(v){return v+' м²'},
		drawSot(v){return v+' сот'},
		drawM2Sot(v){
			if(this.objData.objectType!='Участки' && this.objData.objectType!='Участок' && this.objData.objectType!='Комм.Земля')
				return this.drawM2(v);
			return this.drawSot(v);
		},
		titleRoomsCount(){
			if(this.objData.dealType=='Аренда'){return 'Комнат сдается';}else {return 'Комнат продается';}
		},
		drawUtilityMeters(){
			return  this.objData.utilityMeters?'Арендатором':'Собственником'
		},
		drawOtherUtilities(){
			return this.objData.otherUtilities?'Арендатором':'Собственником';
		},
		drawOtherUtilitiesPayment(){
			return this.drawAmount(this.objData.otherUtilitiesPayment);
		},
		addMonths(date, months) {
			date.setMonth(date.getMonth() + months);
			return date;
		},
		isDetail(key) {
			return key !== 'Всего';
		},
		ChangeGroupServices(val){},
		openContacts(){            
			this.isOpenContacts = !this.isOpenContacts;
		},
		GoToEdit(obj){
			if(obj.draft == true){
				this.$router.push({path: '/data/module/mo/object/add?task_id='+obj.task_id+'&taskend_id='+obj.taskend_id+'&client_id='+obj.client_id+'&service_id='+obj.service_id+'&dealType='+obj.dealType_orig+'&objectType='+obj.objectType_orig})
				// location.href = '/data/module/mo/object/add?task_id='+obj.task_id+'&taskend_id='+obj.taskend_id+'&client_id='+obj.client_id+'&service_id='+obj.service_id+'&dealType='+obj.dealType_orig+'&objectType='+obj.objectType_orig
			}
			else {
				this.$router.push({path: '/data/module/mo/object/'+obj.id+'/edit'});
				// Почему-то через роутер не срабаывает
				// location.href = '/data/module/mo/object/'+obj.id+'/edit';
				// location.href = '/data/module/mo/object/'+obj_id+'/edit?DealType=SELL'+'&ObjectType=FLAT';
				// location.href = '/data/module/mo/object/'+obj_id+'/edit?DealType='+dealType+'&ObjectType='+objectType;
				// console.log();
			}
		},
		GoToHistory(obj_id){
			// location.href = '/data/module/mo/object/'+obj_id+'/history';
			this.$router.push({path:'/data/module/mo/object/'+obj_id+'/history'});
			// console.log();
		},
		distanceInHours(distanceToMetro){
			let hour = 60;
			let distanceToMetroMin;
			let distanceToMetroHours;
			let strDistanceToMetro = '';
			let min = ' мин';
			if(distanceToMetro > hour){
				distanceToMetroHours = Math.floor(distanceToMetro / hour);
				distanceToMetroMin = distanceToMetro % hour;		
				if(distanceToMetroMin == 0){min = ''; distanceToMetroMin = '';}
				strDistanceToMetro = distanceToMetroHours + ' ч ' + distanceToMetroMin + min;
			} else {
				distanceToMetroMin = distanceToMetro;
				strDistanceToMetro = distanceToMetro + ' мин';
			}
			// console.log(distanceToMetroHours + " ч " + minutes + " мин");
			return strDistanceToMetro;
		},
		backByHistory(obj_id){
			// this.$router.back();
			// let path = location.pathname;
			// history.pushState({obj_id: obj_id}, "", path);
			this.$router.go(-1);
			
			// this.$emit("showObjSearchInLead", true);
			// console.log(history);
		},
		getFilter(){
			let filter = {};
			if (!this.$GVO.isEmpty(this.objGetParams)) {
				//console.log('getApi',this.objGetParams);
				filter = this.objGetParams;
			}
			return filter;
		},
		async getServicesSum(){
			// console.log(';suym');
			const filter = this.getFilter();
			// group:'date,adsSourceName'
			let startDt = new Date(this.objServiceDTRange.startDt).toJSON().slice(0, 19).replace('T', ' ');
			startDt = startDt.split(' ')[0]+' 00:00:00';
			let endDt = new Date(this.objServiceDTRange.endDt).toJSON().slice(0, 19).replace('T', ' ');
			endDt = endDt.split(' ')[0]+' 23:59:59';
			const str_range_date = `${startDt};${endDt}`;

			return this.$GVO.ApiCall('services.GET_SERVICES',{flt:{'object_id':this.objData.id,'bMyObj':true,group:'adsSourceName,'+this.groupServiceField,'range_type':'-1','range_date':str_range_date, ...filter, ...{c2p:this.count2page}}})
			.then((objApi) => {
				this.statLoad=true;
				//console.log('getServices',objApi);
				if(objApi.success && Object.keys(objApi.data).length>0){
					// console.log(objApi.data)
					let data={};
					Object.keys(objApi.data).forEach(key=>{
						data[key] = objApi.data[key].map(r=>(r.date = r[this.groupServiceField],r));
					})
					this.arrServicesDays = data;
					if(this.groupServiceField=='day')
						this.servicesStat = objApi.stat;
					// console.log(objApi.data,data)
					// this.arrServicesDays = objApi.data; // data;
					// console.log('getServices',this.arrServicesDays);
				}else{
					this.arrServicesDays = [];
				}
			})
			.catch(errorObjApi => {this.arrServicesDays = [];  console.error(errorObjApi);});
		},
		async getServices(){
			this.objGetParams = this.$GVO.GetAllGet();
			const filter = this.getFilter();

			await this.$GVO.ApiCall('services.GET_SERVICES',{flt:{'object_id':this.objData.id,'bMyObj':true, ...filter, ...{c2p:this.count2page}}})
			.then((objApi) => {
				//console.log('getServices',objApi);
				if(objApi.success && objApi.data.length>0){
					this.arrServices = objApi.data;
					if(objApi.total!=undefined) { this.masApi_total=objApi.total; }
				}else{
					this.arrServices = [];
					this.masApi_total=0;
				}
			})
			.catch(errorObjApi => {this.arrServices = []; this.masApi_total=0; console.error(errorObjApi);});

			// await this.getServicesSum();

	
		},
		// pClick(e){
		// 	this.objGetParams['p'] = parseInt(e);
		// 	this.getServices();
		// },
		pClick(e){
			let strItogGetParams = '';
			let objItogGetParams = this.$GVO.GetAllGet();
			// this.objGetParams['p'] = parseInt(e);
			objItogGetParams.p=parseInt(e);
			strItogGetParams = this.$GVO.ObjToQueryString(objItogGetParams).substr(1);
			this.$router.push({path: location.pathname+'?'+strItogGetParams}); 
			// this.OnFilterApply(strItogGetParams);
			this.getServices(strItogGetParams);
			
			/*
			единственная проблема в этой пагинации в том, что по кнопке Назад мы отходим по пагинации урла, ну и отскроливать вниз будет тоже по этой кнопке
			может сделать сохранение стр не в урле, а сторадж сессии? 
			*/
			
		},
		scrollTo(){
			this.$refs.pagination.scrollIntoView({ behavior: 'smooth' });
		},
		getClientContacts(){
			// const client_id = typeof this.$route.params.client_id == 'undefined'?'':this.$route.params.client_id;
			//console.log(this.objData);
			this.$GVO.ApiCall('GET_CONTAKCS',{obj:'client',flt:{id:this.objData.client_id}})
			.then((objApi) => {
				let client_contacts = [];
				// this.history_total = 0;
				if(objApi.success === true){
					if(objApi.data.length > 0){
						client_contacts = objApi.data;
						// this.client_id = typeof this.$route.params.client_id == 'undefined'?'':this.$route.params.client_id;
						for (let i = 0; i <client_contacts.length; i++) {
							if(client_contacts[i].contact_type == '1') {
								this.phoneintClientContsct =client_contacts[i];
								// this.whatsapp_contact = client_contacts[i];
								// console.log(this.whatsapp_contact);
							}
						}
					}
				}
			}).catch(errorObjApi => console.error(errorObjApi));
		},
		receiveEmitAnchor(data){
			this.emitStatusData = data; //нужная часть, иначе блок с площадками не будет отображаться
			// console.log('receiveEmitAnchor', data);
			this.$emit('moderate', data);
			// console.log('You get this.hohodata: ' + this.emitStatusData);
		},
		getRecallFilters(){
			let filters={};
			// console.log(this.objData);
			if(this.objData.roomsCountTotal) filters.roomsCountTotal = this.objData.roomsCountTotal;
			if(this.objData.MapAddress && this.objData.MapAddress.distr_id) filters.districts = this.objData.MapAddress.distr_id;
			if(this.objData.price) {
				filters.pricemin = this.objData.price * 0.85;
				filters.pricemax = this.objData.price * 1.15;
			}
			if(this.objData.objectType_orig){
				filters.objectType = this.objData.objectType_orig;
			}
			return filters;
		},
		OnTabChange(strTabId){
			// console.log(strTabId);
			if(strTabId=='stats' && ! this.statLoad){
				this.getServicesSum();
			}
			if(strTabId=='goSimular'){
				this.$router.push('/data/RECALL_BASE?'+this.$GVO.ObjToQueryString(this.getRecallFilters()));
			}
		},
		
		
	},
	mounted(){
		// this.setChartData();
		this.objGetParams = this.$GVO.GetAllGet();

		if(this.objGetParams.p && this.objGetParams.p!=''){
			setTimeout(() => {
				this.scrollTo();
			}, '100');
		}

		if(typeof this.objData != 'undefined'){
			this.getServices();
			this.yamap_coords = [this.objData.MapAddress.coords[0],this.objData.MapAddress.coords[1]];
			this.yamap_markers.coords = [this.objData.MapAddress.coords[0],this.objData.MapAddress.coords[1]];
			this.getClientContacts();
			
		}
		// this.getZipalStatus();
		
	}
}
</script>
<style scoped>
.ReSearchMObjBig {width: 100%;}
.flatHeader {display: flex; padding: 15px; justify-content: space-between; flex-wrap: wrap;}
.flatHeader-btn {display: flex; flex-wrap: wrap;}
.flatTitles {display: flex; flex-direction: column;}
.flatTitles h4 {margin-bottom: 5px;}
.flatPhotos {height: auto; flex-shrink: 0;}
.flatPass {flex-shrink: 2;}
.structure-btns > button {width: 100%;}
.icon-folder {width: 18px; height: 18px; background-image: url('/img/icons/folder.svg'); background-repeat: no-repeat;  margin: 0px 7px 3px 0px;}
.flatInfo {display: flex; justify-content: space-between; flex-wrap: wrap; padding: 20px 5px 15px 15px; border-radius: 6px; border: 1px solid #01b0e0;}


/*===carousel===============================*/

.ReSearchMObjBig >>> button:not(:disabled),
[type="button"]:not(:disabled),
[type="reset"]:not(:disabled),
[type="submit"]:not(:disabled) {
  outline: none!important;
}
.ReSearchMObjBig >>>  button:focus {outline: none!important;}
.ReSearchMObjBig >>> .el-carousel__arrow {background-color: rgb(62, 80, 101, 0.32);}
.ReSearchMObjBig >>> .el-carousel__arrow--right {right: 0;}
.ReSearchMObjBig >>> .el-carousel__arrow--left {left: 0;}
.flatPhotos img {height: 100%; border: 1px solid transparent; margin: 0 auto; display: block; object-fit: contain;}
.objectProgress .el-carousel__item:nth-child(2n) {
  background: url("/img/73b0903ac774c473d1cd176b2fbe999f.jpeg") no-repeat center;
  background-size: contain;
} /*план поэтажный*/ 
.objectProgress .el-carousel__item:nth-child(2n + 1) {
  background: url("/img/9bht27nx4iuqcw3n0s4wyns4.png") no-repeat center;
  background-size: contain;
} /*план кв*/ 

/*===collapse===============================*/

.flatPass >>> .card-collapse .card:not(.card-cinc) .card-header {padding-top: 0px;}
.flatPass >>> .card-collapse .card:not(.card-cinc) .card-header a {color: #01b0e0;}
.flatPass >>> .card-collapse .card:not(.card-cinc) .card-body {padding-right: 0px; padding-left: 0px;}
.flatPass-container {display: flex; flex-direction: column;}
.flatPass-row {
	display: flex; justify-content: space-between; margin-bottom: 5px;
}
.flatPass-btn {display: flex; justify-content: space-between; margin-top: 10px;}
.flatPass-btn > button {width: 100%;}
.flatPass-btn > button:first-child {margin-right: 15px;}
.flatPass-row h3, .bigPrice h3 {margin-bottom: 0px;}
.contats-booking {display: flex; flex-wrap: wrap;}

/*===map===============================*/
.objectInfo, .priceFlow  {display: flex; justify-content: space-between; flex-wrap: wrap; border: 1px solid #01b0e0; padding: 20px 5px 0px 15px; border-radius: 6px;}
.objectProgress, .mortgage, .bank-card, .mortgage-calc, .payment {border: 1px solid #01b0e0; border-radius: 6px; padding: 15px;}
.ReSearchMObjBig .map {height: auto;}
.objectInfo h4:first-child {margin-right: 15px;}
.objectAddress {display: flex; flex-wrap: wrap; justify-content: space-between; border-bottom: 1px solid #01b0e0; padding-bottom: 7px;}
.metro {display: flex; align-items: center; flex-wrap: wrap;}
.metroIc {margin-right: 7px;}
.metroIc {margin-bottom: 8px;}
.object-row {display: flex; justify-content: space-between; margin-bottom: 5px;}
.object-row > p:first-child {/*min-width: 100px;*/ margin-right: 10px;}
.objectPass-row {display: flex; flex-wrap: wrap; justify-content: flex-end;}
.objectPass-row p {position: relative; padding-left: 10px;}
.objectPass-row p:not(:first-child)::before {
	content: '';
	position: absolute;
	height: 4px;
	width: 4px;
	border-radius: 50%;
	background: #ccc;
	left: 3px;
	top: 9px;
} 

.service-title {display: flex; flex-wrap: wrap;}
.marker::before {
	content: "\20DD";
	color: #01B0E0;
	padding-right: 18px;
	font-size: 12px;
	font-weight: normal;
}

.bigPrice {width: 100%; padding: 15px; border-radius: 6px; background: linear-gradient(90deg, #1d83bd 0%, #00BF9A 100%); text-align: center; margin-bottom: 15px;}
.bigPrice h3, .bigPrice p {color: #fff;}


/*===chart===============================*/
.priceChart {display: flex; flex-direction: column;}
.priceChart >>> .card-chart {border: 1px solid #01b0e0; border-radius: 6px;}
.priceChart >>> .card-chart h4 {margin-bottom: 0px;}
.priceChart >>> .card-chart .chart-area {height: auto;}

/*===mortgage===============================*/
.mortgage-title, .bank-header {display: flex; justify-content: space-between; flex-wrap: wrap; margin-bottom: 10px;}
.bank-header {display: flex; flex-wrap: nowrap;}
.bank-col {display: flex; flex-direction: column; justify-self: flex-end;}
.bank-col p {margin-bottom: 0px;}
.bank-text {display: flex; flex-direction: column;}
.mortgage-content {display: flex; flex-wrap: wrap;}
.banks {padding-left: 0px; padding-right: 5px;}
.banks-scroll {height: 500px; overflow-y: scroll; padding-right: 10px;}
.calcs {padding-right: 0px;}
.calcs >>> .input-group-append {cursor: pointer;}
.bank-photo-img {display: block; max-width: 100px; height: auto;}
.bank-card >>> .card-body {padding: 0px;}
.white-content .card:not(.card-white) .bank-card:hover {box-shadow: 0px 0px 10px rgba(139, 99, 127, 0.84); cursor: pointer;}
.bank-card:hover {box-shadow: 0px 0px 10px rgba(139, 99, 127, 0.84); cursor: pointer; border:1px solid #BA54F5;}
.bankselected {box-shadow: 0px 0px 10px rgba(139, 99, 127, 0.84); border:1px solid #BA54F5;}
.bank-card.active {box-shadow: 0px 0px 10px rgba(139, 99, 127, 0.84); border:1px solid #BA54F5;}
.IsBankTab {box-shadow: 0px 0px 10px rgba(139, 99, 127, 0.84); cursor: pointer; outline: none; border:1px solid #BA54F5;}
/*.bank-card:active {border:1px solid #BA54F5; box-shadow: 0px 0px 10px rgba(139, 99, 127, 0.84); cursor: pointer;}*/
.calc-row {display: flex; flex-wrap: wrap;}
.ReSearchMObjBig >>> .form-control + .input-group-append .input-group-text {background: transparent;}
.monthly-pay {display: flex; justify-content: space-between; flex-wrap: wrap;}
.monthly-pay h4 {color: #00bf9a;}
.gkTaskLink  {color: #9e77f3; font-weight: 300;}
.gkTaskLink:hover {color: #01b0e0; cursor: pointer;}
.ReSearchMObjBig >>> .bank-text br {content: ""; display: block; margin-top: 5px;}
.flat-carousel img {background-color: #fff;}
.metro-row  {display: flex; flex-wrap: wrap;}
.ReSearchMObjBig >>> .metro-row {list-style: none; padding-left: 0px;}
.ReSearchMObjBig >>> .zipal-errors {margin-bottom: 15px; border: 1px dashed #F84E54; border-radius: 6px; padding: 10px; grid-gap: 10px;}
.ReSearchMObjBig >>> .zipal-error-text {white-space:pre-wrap; line-height: 0.8;}
.ReSearchMObjBig >>>  .sticky-container {position: relative;}
.ReSearchMObjBig >>>  .sticky-item {display: flex; flex-direction: column; position: sticky; top: 15px; z-index: 2; background: inherit;}
.ReSearchMObjBig >>>  .clientinfo {    border: 1px dashed #01b0e0; padding: 10px 10px 5px 10px; border-radius: 6px;}
.objectDescrNumber {font-size: 14px; color:#01b0e0;}
.objectDescr{font-size: 16px; white-space: pre-wrap;}
.ReSearchMObjBig >>> .nav-pills .nav-item .nav-link { padding: 1px 23px;}

.stat-conf > * {display: inline-block; margin-right: 10px; }
.stat-conf .stat-conf-item > span{vertical-align: super; margin-right: 5px;}
.tab-label > span{display: inline-flex!important;}
.stat-tabs >>> .nav-pills.nav-pills:not(.flex-column) .nav-item:not(:last-child) .nav-link {
	margin-bottom: 15px;
}

.stat-container {
	display: flex;
	justify-content: space-between;
	width: 100%;
}
.stat-box {
	border: 1px solid #ccc;
	padding: 20px;
	flex: 1;
	margin-right: 10px;
}

@media (max-width: 768px) {	
	.flatPass {margin-top: 20px; padding: 0px 10px 0px 5px!important;}
	.flatPass-btn {flex-wrap: wrap;}
	.flatPass-btn > button:first-child {margin-right: 0px;}
	.calcs {order: 1; margin-bottom: 20px;}
	.banks {order: 2; padding-right: 0px;}
	.monthly-pay h4 {margin-bottom: 0px;}
	.calcs {padding-left: 0px;}
	.bank-header {flex-wrap: wrap;}
	.mortgage-calc .btn, .flatHeader-btn {margin-top: 15px; width: 100%;}
	.flatHeader {padding: 15px 0px;}
}
@media (max-width: 525px){
	.stat-container{flex-direction: column;}
	.stat-container > .stat-box{width: 100%; margin-bottom: 15px;}
}



</style>
